export function isSearchBarHidden(
    attrs: RecordListBlock['config']['attributes'],
    parentView?: ViewDto
): boolean {
    const { hide_search_bar } = attrs
    if (typeof hide_search_bar !== 'undefined') return hide_search_bar

    return parentView?.options.hide_search_bar ?? false
}
